import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from '../../../node_modules/ngx-toastr';
import { Role } from '../roles/models/role.model';

@Injectable()
export class RolesService {

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private rootUrl: string,
    private notificationsService: ToastrService,
  ) { }
  GetAll(){
    return this.http.get<Role[]>(`${this.rootUrl}/roles`);
  }
  Create(role:Role){
    return this.http.post(`${this.rootUrl}/roles`, role);
  }

  Assign(user:string,roles:string[]){
    return this.http.patch(`${this.rootUrl}/roles/${user}`, roles);
  }
}
